'use client';

import { NavLink } from '@/features/navigation/NavLink';
import { useSiteSettings } from '@/components/providers';

type RestProps = {
    className?: string;
};

export function NavigationFooter({ className }: RestProps) {
    const settings = useSiteSettings();
    const items = settings.navigation?.footer ?? [];

    return (
        <nav className={className} aria-label="Footer navigation">
            <ul className="flex gap-6 justify-center">
                {items.map((item) => (
                    <li key={item._key}>
                        <NavLink item={item} className="underline" />
                    </li>
                ))}
            </ul>
        </nav>
    );
}
